export default [
    {
        path: '/_whatsapp',
        name: 'whatsapp|scan',
        component: () => import('@/views/whatsapp/scan.vue')
    },
]